import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-days",
  "use": "icon-days-usage",
  "viewBox": "0 0 120 116.58",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 120 116.58\" id=\"icon-days\"><defs><style>#icon-days .cls-1{fill:#b6c2cd;}#icon-days .cls-2{fill:#324558;}</style></defs><title>3全天候服务</title><path class=\"cls-1\" d=\"M1246.27,534a39,39,0,1,0,39-39,39,39,0,0,0-39,39Zm0,0\" transform=\"translate(-1212.81 -460.65)\" /><path class=\"cls-2\" d=\"M1272.81,460.65a60.07,60.07,0,0,0-60,60v46.07a10.53,10.53,0,0,0,10.52,10.52h15.38a10.53,10.53,0,0,0,10.52-10.52V535.1a10.53,10.53,0,0,0-10.52-10.52h-17.39v-3.94a51.5,51.5,0,1,1,103,0v3.94h-17.39a10.53,10.53,0,0,0-10.52,10.52v31.61a10.53,10.53,0,0,0,10.52,10.52h15.38a10.53,10.53,0,0,0,10.52-10.52V520.65a60.07,60.07,0,0,0-60-60Zm-32.09,74.46v31.61a2,2,0,0,1-2,2h-15.38a2,2,0,0,1-2-2V533.1h17.4a2,2,0,0,1,2,2Zm83.59,31.61a2,2,0,0,1-2,2h-15.38a2,2,0,0,1-2-2V535.11a2,2,0,0,1,2-2h17.4v33.62Zm0,0\" transform=\"translate(-1212.81 -460.65)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/days.svg
// module id = 5MJ5
// module chunks = 19